import axios from "axios";
import firebase from "firebase";
// const BASE_URL = 'http://api.oddjob-staging.vn-nest.tech';
const BASE_URL = "https://backend.oddjob.vn/v1.1";
// const BASE_URL = "https://staging.oddjob.vn/backend";
// const BASE_URL = 'http://localhost:6610';

// class TokenManager{
//     constructor(){
//     }
//     async _getToken(){
//         const user = firebase.auth().currentUser;
//         if(user){
//             return user.getIdToken(true).then(token =>{
//                 return token;
//             })
//         }
//         return null;
//     }
// }
const ErrorCodes = {
  SUCCESS: "success",
};

class OddJob {
  constructor() {
    this.users = new Users(this);
    this.auth = new Auth(this);
    this.file = new File(this);
    this.serviceProviders = new ServiceProviders(this);
    this.settings = new Settings(this);
    this.userGroups = new UserGroups(this);
    this.customers = new Customers(this);
    // this.servces = new Services(this);
    // this.tokenManager = new TokenManager(this);
  }

  async getToken() {
    // return null; // UPDATE THIS
    const user = await firebase.auth().currentUser;
    if (user) {
      return user.getIdToken(true).then((token) => {
        return token;
      });
    }
    return null;
  }

  // async getUserHaveToken(path, params, data){
  //   let token = await this.getToken();
  //   return axios({
  //     method: "get",
  //     url: BASE_URL + path,
  //     headers: {
  //       authorization: token
  //     },
  //     params: params,
  //     data: data,
  //   });
  // }

  async _get(path, params, data) {
    let token = await this.getToken();
    if (token) {
      return axios({
        method: "get",
        url: BASE_URL + path,
        headers: {
          authorization: token,
        },
        params: params,
        data: data,
      });
    }
    return axios({
      method: "get",
      url: BASE_URL + path,
      headers: {},
      params: params,
      data: data,
    });
  }

  async _post(path, data, params) {
    let token = await this.getToken();
    if (token) {
      return axios({
        method: "post",
        url: BASE_URL + path,
        headers: {
          authorization: token,
        },
        data: data,
        params: params,
      });
    }
    return axios({
      method: "post",
      url: BASE_URL + path,
      headers: {},
      params: params,
      data: data,
    });
  }
  async _put(path, data, params) {
    let token = await this.getToken();
    return axios({
      method: "put",
      url: BASE_URL + path,
      headers: {
        authorization: token,
      },
      params: params,
      data: data,
    });
  }

  async _delete(path, params, data) {
    let token = await this.getToken();
    return axios({
      method: "delete",
      url: BASE_URL + path,
      headers: {
        authorization: token,
      },
      params: params,
      data: data,
    });
  }
}
class Settings {
  constructor(client) {
    this._client = client;
  }

  async getCategories(filters) {
    return await this._client._get("/categories", filters);
  }

  async createCategory(data) {
    return await this._client._post("/categories", data);
  }

  async setCategory(id, data) {
    return await this._client._put(`/categories/${id}`, data);
  }

  async getCategoryById(id) {
    return await this._client._get(`/categories/${id}`);
  }

  async getConfigVersion(id) {
    return await this._client._get(`/configs/${id}`);
  }

  async setConfigVersion(id, value) {
    return await this._client._put(`/configs/${id}`, { value });
  }

  async getConfigFaqUrl(id) {
    return await this._client._get(`/configs/${id}`);
  }

  async setConfigFaqUrl(id, value) {
    return await this._client._put(`/configs/${id}`, { value });
  }

  async getConfigTermsOfUser(id) {
    return await this._client._get(`/configs/${id}`);
  }

  async setConfigTermsOfUser(id, value) {
    return await this._client._put(`/configs/${id}`, { value });
  }

  async getConfigContactUrl(id) {
    return await this._client._get(`/configs/${id}`);
  }

  async setConfigContactUrl(id, value) {
    return await this._client._put(`/configs/${id}`, { value });
  }

  async getConfigFeedbackUrl(id) {
    return await this._client._get(`/configs/${id}`);
  }

  async setConfigFeedbackUrl(id, value) {
    return await this._client._put(`/configs/${id}`, { value });
  }

  async getConfigTermsPolicyUrl(id) {
    return await this._client._get(`/configs/${id}`);
  }

  async setConfigTermsPolicyUrl(id, value) {
    return await this._client._put(`/configs/${id}`, { value });
  }

  async getConfigAppInfoUrl(id) {
    return await this._client._get(`/configs/${id}`);
  }

  async setConfigAppInfoUrl(id, value) {
    return await this._client._put(`/configs/${id}`, { value });
  }

  async getConfigDefaultRadius(id) {
    return await this._client._get(`/configs/${id}`);
  }

  async setConfigDefaultRadius(id, value) {
    return await this._client._put(`/configs/${id}`, { value });
  }

  async getConfigNoticesPeriod(id) {
    return await this._client._get(`/configs/${id}`);
  }

  async setConfigNoticesPeriod(id, value) {
    return await this._client._put(`/configs/${id}`, { value });
  }

  async getConfigHotline(id) {
    return await this._client._get(`/configs/${id}`);
  }

  async setConfigHotline(id, value) {
    return await this._client._put(`/configs/${id}`, { value });
  }

  async getConfigMaxLocation(id) {
    return await this._client._get(`/configs/${id}`);
  }

  async setConfigMaxLocation(id, value) {
    return await this._client._put(`/configs/${id}`, { value });
  }

  async getConfigMaxPhoneNumber(id) {
    return await this._client._get(`/configs/${id}`);
  }

  async setConfigMaxPhoneNumber(id, value) {
    return await this._client._put(`/configs/${id}`, { value });
  }

  async getConfigMaxBanner(id) {
    return await this._client._get(`/configs/${id}`);
  }

  async setConfigMaxBanner(id, value) {
    return await this._client._put(`/configs/${id}`, { value });
  }

  async getConfigMaxQuotation(id) {
    return await this._client._get(`/configs/${id}`);
  }

  async setConfigMaxQuotation(id, value) {
    return await this._client._put(`/configs/${id}`, { value });
  }

  async getConfigContactEmail() {
    return await this._client._get(`/configs/contact-email`);
  }

  async setConfigContactEmail(data) {
    return await this._client._put(`/configs/contact-email`, data);
  }

  async getSupportedLanguages() {
    return await this._client._get(`/configs/supported-languages`);
  }

  async setSupportedLanguages(value) {
    return await this._client._put(`/configs/supported-languages`, { value });
  }

  async getSupportedPhoneRegions() {
    return await this._client._get(`/configs/supported-phone-regions`);
  }

  async setSupportedPhoneRegions(value) {
    return await this._client._put(`/configs/supported-phone-regions`, {
      value,
    });
  }

  async getLanguages() {
    return await this._client._get(`/configs/languages`);
  }

  async getPhoneRegions() {
    return await this._client._get(`/configs/phone-regions`);
  }

  async getConstants() {
    return await this._client._get("/enums");
  }
  async getConfigs() {
    return await this._client._get("/configs");
  }
}

class ServiceProviders {
  constructor(client) {
    this._client = client;
  }

  async createProviderDefaultUser(providerId, user) {
    return await this._client._post(
      `/providers/${providerId}/default-user`,
      user
    );
  }

  async createProvider(provider) {
    return await this._client._post("/providers", provider);
  }

  async updateProvider(id, provider) {
    return await this._client._put(`/providers/${id}`, provider);
  }

  async getProviderById(id) {
    return await this._client._get(`/providers/${id}`);
  }

  async getProviderTemp(id) {
    return await this._client._get(`/providers/${id}/temporary`);
  }

  async approveProviderTemp(id) {
    return await this._client._put(`/providers/${id}/approve-temporary`);
  }

  async countProviders() {
    return await this._client._get(`/providers/count`);
  }

  async findSimple(filter) {
    return await this._client._get("/providers-simple-search", filter);
  }

  async getServiceProviders(filter) {
    return await this._client._get("/providers", filter);
  }

  async setVerified(providerId) {
    return await this._client._put(`/providers/${providerId}/set-verified`);
  }

  async setVerifiedStatus(providerId) {
    return await this._client._post(
      `/providers/${providerId}/request-verification`
    );
  }

  async getProvidersCsvLink(project) {
    let projectStr = "";
    if (project) {
      projectStr = `project=${JSON.stringify(project)}`;
    }
    return encodeURI(`${BASE_URL}/providers?asCsv=true&${projectStr}`);
  }

  async getLocations(providerId) {
    return this._client._get(`/providers/${providerId}/locations`);
  }

  async setLocationsProvider(providerId, { locations }) {
    console.log("providerID", providerId);
    return this._client._put(`/providers/${providerId}/locations`, {
      locations,
    });
  }

  async findByLocations(filter) {
    return this._client._get(`/providers-locations`, filter);
  }

  async getFeedbackSummary(providerIds) {
    return this._client._get(`/providers-feedbacks`, { providerIds });
  }

  async feedbacks(filter) {
    return this._client._get(
      `/providers/_me/services/feedbacks/search`,
      filter
    );
  }

  async getFeedbackByServiceId(serviceId) {
    return this._client._get(`/providers/_me/services/${serviceId}/feedbacks`);
  }

  async countFeedbacks() {
    return this._client._get(`/providers/_me/services/feedbacks/count`);
  }

  async countCaculateTotalReport(feedbackId) {
    return this._client._get(
      `/providers/_me/services/null/feedbacks/${feedbackId}/total-report`
    );
  }

  async getServices(filter) {
    return await this._client._get("/providers/_me/services/search", filter);
  }

  async getServicesByProviderId(providerId) {
    return await this._client._get(`/providers/${providerId}/services`);
  }

  async createServices(providerId, { categoryIds }) {
    return await this._client._put(`/providers/${providerId}/services`, {
      categoryIds,
    });
  }

  async deleteService(providerId, serviceId) {
    return await this._client._delete(
      `/providers/${providerId}/services/${serviceId}`
    );
  }

  async getQuotation(providerId, serviceId) {
    return await this._client._get(
      `/providers/${providerId}/services/${serviceId}/packages`
    );
  }

  async createQuotation(providerId, serviceId, data) {
    return await this._client._post(
      `/providers/${providerId}/services/${serviceId}/packages`,
      data
    );
  }

  async updateQuotation(providerId, serviceId, packageId, data) {
    return await this._client._put(
      `/providers/${providerId}/services/${serviceId}/packages/${packageId}`,
      data
    );
  }

  async deleteQuotation(providerId, serviceId, packageId) {
    return await this._client._delete(
      `/providers/${providerId}/services/${serviceId}/packages/${packageId}`
    );
  }
}

class Auth {
  constructor(client) {
    this._client = client;
  }

  async getProfile(params) {
    return await this._client._get("/users/_me", params);
  }

  async changeProfile(model) {
    return await this._client._put("/users/_me", model);
  }

  async sendAuthOtpByPhone(phone) {
    return await this._client._post("/auth/login/phone-otp", { phone });
  }

  async verifyAuthOtp(phone, otp) {
    return await this._client._post("/auth/login/phone", { phone, otp });
  }

}

class Customers {
  constructor(client) {
    this._client = client;
  }

  async getCustomers(filter) {
    return await this._client._get("/customers", filter);
  }

  async countCustomers() {
    return await this._client._get("/customers/count");
  }

  async createSubscriber(data) {
    return await this._client._post("/subscribers/", data);
  }

  async getCustomersCsvLink(project) {
    let projectStr = "";
    if (project) {
      projectStr = `project=${JSON.stringify(project)}`;
    }
    return encodeURI(`${BASE_URL}/customers?asCsv=true&${projectStr}`);
  }
}

class Users {
  constructor(client) {
    this._client = client;
  }

  async currentUser() {
    return await this._client._get("/users/_me");
  }

  async find(filter) {
    return await this._client._get("/users", filter);
  }
  async getUserInfo(filter) {
    return await this._client._get("/users", filter);
  }

  async getUserById(id) {
    return await this._client._get(`/users/${id}`);
  }

  async createUser(data) {
    return await this._client._post("/users", data);
  }

  async updateUser(id, data) {
    return await this._client._put(`/users/${id}`, data);
  }
}

class UserGroups {
  constructor(client) {
    this._client = client;
  }

  async getGroupUsers(groupId) {
    return this._client._get("/user-groups/" + groupId);
  }

  async getUsersInGroup(groupId) {
    return this._client._get(`/user-groups/${groupId}/users`);
  }

  async getGroups() {
    return this._client._get("/user-groups");
  }

  async createGroup(group) {
    return this._client._post("/user-groups", group);
  }

  async updateGroup(group) {
    return this._client._put("/user-groups/" + group._id, group);
  }

  async addUser(groupId, userId) {
    return this._client._put("/user-groups/" + groupId + "/users/" + userId);
  }

  async removeUser(groupId, userId) {
    return this._client._delete("/user-groups/" + groupId + "/users/" + userId);
  }

  async deleteGroup(groupId) {
    return this._client._delete(`/user-groups/${groupId}`);
  }
}

class File {
  constructor(client) {
    this._client = client;
  }

  getImgConfig(fileType) {
    return this._client._post("/files", fileType).then((body) => {
      if (body.data.code === ErrorCodes.SUCCESS) {
        return Promise.resolve(body.data.results[0]);
      }
    });
  }

  uploadFile(url, fileObj) {
    return axios.put(url, fileObj, {
      headers: {
        "Content-Type": fileObj.type,
      },
    });
  }
}

export default OddJob;
